/*
 * @Author: zhangzhian@linshimuye.com
 * @Date: 2023-01-30 09:47:22
 * @LastEditors: Gyan
 * @LastEditTime: 2023-08-24 17:01:50
 * @FilePath: \dhr_frontend\src\assets\data\index.js
 * @Description: 静态数据
 * @ImportRoute: import {} from '@/assets/data/index.js'
 */
// 全司部门属性
export const companyDepartmentAttr = {
  companyMainName: "广东林氏家居股份有限公司",
  deptId: "40288088349f1b590134a15b667d0007",
  departmentId: "40288088349f1b590134a15b667d0007",
  deptName: "广东林氏家居股份有限公司",
  departmentName: "广东林氏家居股份有限公司",
  sixDepartmentName: "广东林氏家居股份有限公司",
  deptNo: "AA",
  departmentNo: "AA",
  deptProName: "管理部门"
}